import { getQueryParam } from './common';
import { fetcher } from './fetcher';

const SHOPPING_LIST_PATH = '/promote/app/shopping-list';

export const downloadButton = {
  dom: null,
  init() {
    let uuid = '';
    let week = '';

    if (location.pathname === SHOPPING_LIST_PATH) {
      uuid = getQueryParam('uuid');
      week = getQueryParam('week');
    } else {
      uuid = location.pathname.match(/diets\/(.*)\/week/)[1];
      week = location.pathname.replace(/^.+\/week\//, '');
    }

    this.dom = {
      loader: document.querySelector('.loader-pdf'),
      downloadButton: document.querySelector('.download-plan-button'),
      errorMessage: document.querySelector('#error_generate_pdf'),
      data: {
        uuid,
        week,
      },
    };
    this.dom.loader.classList.remove('hidden');
    this.dom.downloadButton.setAttribute('disabled', '');
    this.dom.errorMessage.classList.add('hidden');
    this.getFileName();
  },

  getFileName() {
    const url = `${getHost()}/diets/generate-pdf-meal-plan`;
    fetcher
      .post(url, this.dom.data, {
        Accept: 'application/json',
      })
      .then(({ fileName }) => {
        this.dom.data.fileName = fileName;
        this.checkForFile(this.dom.data, 1);
      })
      .catch(error => {
        this.failGeneratePdf();
      });
  },

  checkForFile(data, retry) {
    if (retry > 20) {
      return this.failGeneratePdf();
    }
    const url = `${getHost()}/diets/show-plan?${this.toQueryString(data)}`;
    fetcher
      .get(url, {
        Accept: 'application/json',
      })
      .then(({ path }) => {
        if (!path) {
          setTimeout(() => {
            this.checkForFile(data, retry + 1);
          }, 1000);
        }
        this.dom.downloadButton.removeAttribute('disabled');
        this.dom.loader.classList.add('hidden');

        data.path = path;
        this.downloadFile(data);
      })
      .catch(error => {
        setTimeout(() => {
          this.checkForFile(data, retry + 1);
        }, 1000);
      });
  },

  downloadFile(data) {
    window.location.href = getHost() + '/diets/download-plan?' + this.toQueryString(data);
  },

  failGeneratePdf() {
    this.dom.downloadButton.removeAttribute('disabled');
    this.dom.loader.classList.add('hidden');
    this.dom.errorMessage.classList.remove('hidden');
  },

  toQueryString(params) {
    return Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
  },

  buildBackButtonUrl(uuid, week) {
    document.querySelector('#js-diets-back-button').href = `/diets/${uuid}/week/${week}`;
  },
};

document.addEventListener('click', e => {
  e.stopPropagation();
  const downloadPdfButton = document.querySelector('#buttonDownload');
  if (
    e.target.parentElement === downloadPdfButton ||
    e.target === downloadPdfButton ||
    e.target.parentElement?.parentElement === downloadPdfButton
  ) {
    downloadButton.init();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (location.pathname === SHOPPING_LIST_PATH) {
    downloadButton.buildBackButtonUrl(getQueryParam('uuid'), getQueryParam('week'));
  }
});
